var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M7.679 12.676C7.686 14.473 8.833 16 10.973 16c2.12 0 3.303-1.527 3.295-3.324v-.79c.008-1.811-1.147-3.323-3.295-3.323-2.11 0-3.287 1.526-3.294 3.324v.789ZM0 4.113c.007 1.797 1.154 3.31 3.288 3.31 2.126 0 3.31-1.498 3.302-3.31v-.789C6.597 1.512 5.443 0 3.288 0 1.198 0 .008 1.512 0 3.324v.79ZM.234 16H2.14l11.4-16h-1.907L.234 16Zm9.57-4.113c.008-.716.293-1.454 1.17-1.454.92 0 1.161.738 1.154 1.454v.789c.007.716-.263 1.44-1.155 1.44-.89 0-1.161-.746-1.168-1.44v-.79ZM2.142 3.324c.007-.694.277-1.454 1.147-1.454.92 0 1.169.738 1.161 1.454v.79c.008.715-.27 1.439-1.161 1.439-.862 0-1.14-.724-1.147-1.44v-.789Z",
    fill: "currentColor"
  })));
};
export default SvgPercent;